import errors from './errors.json';

export default errors;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/errors/index.js
// module id = 628
// module chunks = 0